const TagalysCustomisations = {};
TagalysCustomisations.lastAddedProductId = null;
TagalysCustomisations.productBasedWidgetInstanceCount = 0;
TagalysCustomisations.cartDrawerWidgetRefreshFrame = null;
TagalysCustomisations.cartDrawerWidgetRefreshTimeout = null;
TagalysCustomisations.cartDrawerWidgetLoadingObserver = null;
TagalysCustomisations.cartDrawerWidgetLoadingTimeout = null;

let defaultTagalysLocale = window.tagalysConfig.locale;
let defaultTagalysCurrencyCode = window.tagalysConfig.currencyCode;
const defaultTagalysCurrencyLabel = window.tagalysConfig.currencyLabel;
let defaultTagalysCountry = window.tagalysConfig.country;
const defaultTagalysBaseCountry = window.tagalysConfig.baseCountry;
let defaultTagalysLanguage = window.tagalysConfig.language;
const defaultTagalysServerUrl = window.tagalysConfig.serverUrl;
const storefrontApiAccessToken = window.tagalysConfig.storefrontApiAccessToken;
const tagalysProductBasedRecommendationId = window.tagalysConfig.tagalysProductBasedRecommendationId;
const tagalysDefaultProductBasedProductId = window.tagalysConfig.tagalysDefaultProductBasedProductId;

if (window?.Shopify?.currency.active) {
  defaultTagalysCurrencyCode = window.Shopify.currency.active;
}

if (window?.Shopify?.country) {
  defaultTagalysCountry = window.Shopify.country;
  defaultTagalysLanguage = window.Shopify.locale;
  defaultTagalysLocale = `${defaultTagalysLanguage}-${defaultTagalysCountry.toUpperCase()}`;
}

TagalysCustomisations.getVariantOptionValues = function (variant) {
  if (Array.isArray(variant?.options) && variant.options.length > 0) {
    return variant.options.filter(Boolean);
  }

  return [variant?.option1, variant?.option2, variant?.option3].filter(Boolean);
};

TagalysCustomisations.getVariantLabel = function (variant) {
  const optionValues = TagalysCustomisations.getVariantOptionValues(variant);

  if (optionValues.length > 0) {
    return optionValues.join(' / ');
  }

  return variant?.title || '';
};

TagalysCustomisations.updateProductCardPrices = function (cardElement, helpers, variants, fallbackVariant) {
  if (!cardElement || !helpers) return;

  const pricesElement = cardElement.querySelector('[data-tagalys-product-prices]');
  if (!pricesElement) return;

  const selectedVariantId = cardElement.querySelector('[data-tagalys-variant-select]')?.value;
  const variant =
    variants.find((entry) => String(entry.id) === String(selectedVariantId)) ||
    fallbackVariant ||
    variants.find((entry) => entry.available !== false) ||
    variants[0];

  if (!variant || variant.price == null) return;

  const isOnSale = helpers.isProductOnSale(variant.compare_at_price, variant.price);
  const regularPriceSpanClass =
    'cart-drawer__product-card-price cart-drawer__product-card-price--regular product-price-regular';

  pricesElement.classList.toggle('discounted', isOnSale);
  pricesElement.classList.toggle('full-price', !isOnSale);

  let discountedEl = pricesElement.querySelector('.cart-drawer__product-card-price--discounted');
  let regularEl = pricesElement.querySelector('.cart-drawer__product-card-price--regular');

  if (isOnSale) {
    if (!discountedEl) {
      discountedEl = document.createElement('span');
      discountedEl.className =
        'cart-drawer__product-card-price cart-drawer__product-card-price--discounted product-price-discounted';
      pricesElement.prepend(discountedEl);
    }

    discountedEl.textContent = helpers.formatCurrency(variant.price);

    if (!regularEl) {
      regularEl = document.createElement('span');
      regularEl.className = regularPriceSpanClass;
      pricesElement.appendChild(regularEl);
    }

    regularEl.textContent = helpers.formatCurrency(variant.compare_at_price);
    return;
  }

  discountedEl?.remove();

  if (!regularEl) {
    regularEl = document.createElement('span');
    regularEl.className = regularPriceSpanClass;
    pricesElement.appendChild(regularEl);
  }

  regularEl.textContent = helpers.formatCurrency(variant.price);
};

TagalysCustomisations.hasMeaningfulVariantLabel = function (variant, { hasMultipleVariants = false } = {}) {
  const optionValues = TagalysCustomisations.getVariantOptionValues(variant);

  if (optionValues.length > 1) {
    return true;
  }

  if (optionValues.length === 1) {
    return hasMultipleVariants;
  }

  return Boolean(variant?.title) && hasMultipleVariants;
};

TagalysCustomisations.getProductVariants = function (product) {
  const candidates = [];

  if (Array.isArray(product?.variants)) {
    candidates.push(...product.variants);
  }

  if (product?.selected_or_first_available_variant) {
    candidates.push(product.selected_or_first_available_variant);
  }

  if (product?.first_available_variant) {
    candidates.push(product.first_available_variant);
  }

  const uniqueVariants = [];
  const seenVariantIds = new Set();

  candidates.forEach((variant) => {
    if (!variant?.id || seenVariantIds.has(String(variant.id))) {
      return;
    }

    seenVariantIds.add(String(variant.id));
    uniqueVariants.push(variant);
  });

  return uniqueVariants;
};

TagalysCustomisations.recommendationCarouselDragState = {
  startX: 0,
  startY: 0,
  isPointerDown: false,
  allowClick: true,
  activePointerId: null,
};

TagalysCustomisations.resetRecommendationCarouselDragState = function ({ allowClick = true } = {}) {
  TagalysCustomisations.recommendationCarouselDragState.isPointerDown = false;
  TagalysCustomisations.recommendationCarouselDragState.allowClick = allowClick;
  TagalysCustomisations.recommendationCarouselDragState.activePointerId = null;
};

TagalysCustomisations.getQuickAddState = function (product) {
  const variants = TagalysCustomisations.getProductVariants(product);
  const quickAddVariants = variants.filter((variant) => !variant?.requires_selling_plan);
  const availableVariants = quickAddVariants.filter((variant) => variant.available !== false);
  const firstAvailableVariant = availableVariants[0] || null;
  const hasMultipleVariants = variants.length > 1;
  const hasVariantSelector =
    quickAddVariants.length > 1 ||
    (quickAddVariants.length === 1 &&
      TagalysCustomisations.hasMeaningfulVariantLabel(quickAddVariants[0], { hasMultipleVariants }));

  return {
    variants: quickAddVariants,
    availableVariants,
    firstAvailableVariant,
    hasVariantSelector,
  };
};

TagalysCustomisations.stopCardInteraction = function (event) {
  event.preventDefault();
  event.stopPropagation();
};

TagalysCustomisations.setQuickAddError = function (cardElement, message = '') {
  if (!cardElement) return;

  const errorElement = cardElement.querySelector('[data-tagalys-quick-add-error]');
  if (!errorElement) return;

  errorElement.hidden = !message;
  errorElement.textContent = message;
};

TagalysCustomisations.setQuickAddLoading = function (buttonElement, isLoading) {
  if (!buttonElement) return;

  buttonElement.classList.toggle('loading', isLoading);
  buttonElement.disabled = isLoading;
  buttonElement.setAttribute('aria-busy', isLoading ? 'true' : 'false');

  const labelElement = buttonElement.querySelector('[data-tagalys-add-label]');
  if (labelElement) {
    labelElement.textContent = isLoading ? window.tagalysConfig.adding : window.tagalysConfig.add;
  }
};

TagalysCustomisations.getProductIdFromCartAddResponse = function (response) {
  const productId = response?.items?.[0]?.product_id || response?.product_id;
  return productId ? String(productId) : null;
};

TagalysCustomisations.setLastAddedProductId = function (productId) {
  TagalysCustomisations.lastAddedProductId = productId ? String(productId) : null;
};

TagalysCustomisations.syncCartDrawerRecommendationContext = function (cartData) {
  if (!cartData) return;

  const cartProductIds = Array.isArray(cartData?.items)
    ? cartData.items
        .map((item) => item?.product_id)
        .filter(Boolean)
        .map(String)
    : [];
  const responseProductId = TagalysCustomisations.getProductIdFromCartAddResponse(cartData);

  if (cartProductIds.length === 0) {
    if (responseProductId) {
      TagalysCustomisations.setLastAddedProductId(responseProductId);
    }
    return;
  }

  if (TagalysCustomisations.lastAddedProductId && cartProductIds.includes(TagalysCustomisations.lastAddedProductId)) {
    return;
  }

  TagalysCustomisations.setLastAddedProductId(responseProductId || cartProductIds[0]);
};

TagalysCustomisations.getCartProductIdsFromMarkup = function () {
  const cartItems = document.querySelectorAll('#CartDrawer [data-cart-product-id]');
  const seenProductIds = new Set();

  return Array.from(cartItems)
    .map((item) => item.dataset.cartProductId)
    .filter((productId) => {
      if (!productId || seenProductIds.has(productId)) {
        return false;
      }

      seenProductIds.add(productId);
      return true;
    });
};

TagalysCustomisations.getProductBasedWidgetProductIds = function () {
  const cartProductIds = TagalysCustomisations.getCartProductIdsFromMarkup();
  const lastAddedProductId = TagalysCustomisations.lastAddedProductId;
  const defaultProductId = tagalysDefaultProductBasedProductId ? String(tagalysDefaultProductBasedProductId) : null;

  if (lastAddedProductId && cartProductIds.includes(lastAddedProductId)) {
    return [lastAddedProductId, ...cartProductIds.filter((productId) => productId !== lastAddedProductId)].slice(0, 3);
  }

  if (cartProductIds.length > 0) {
    return cartProductIds.slice(0, 3);
  }

  return defaultProductId ? [defaultProductId] : [];
};

TagalysCustomisations.getProductBasedWidgetSelector = function (widgetElement) {
  TagalysCustomisations.productBasedWidgetInstanceCount += 1;
  widgetElement.innerHTML = '';
  widgetElement.setAttribute(
    'data-tagalys-widget-instance',
    String(TagalysCustomisations.productBasedWidgetInstanceCount)
  );

  return `[data-product-based-widget][data-tagalys-widget-instance="${TagalysCustomisations.productBasedWidgetInstanceCount}"]`;
};

TagalysCustomisations.getCartDrawerWidgetElement = function () {
  return document.querySelector('[data-product-based-widget]');
};

TagalysCustomisations.getCartDrawerWidgetHost = function (
  widgetElement = TagalysCustomisations.getCartDrawerWidgetElement()
) {
  return widgetElement?.closest('[data-product-based-widget-host]') || null;
};

TagalysCustomisations.setCartDrawerWidgetLoading = function (widgetHost, isLoading) {
  if (!widgetHost) return;

  widgetHost.classList.toggle('is-loading', isLoading);

  const activeWidgetElement = widgetHost.querySelector('[data-product-based-widget]');
  if (activeWidgetElement) {
    activeWidgetElement.setAttribute('aria-busy', isLoading ? 'true' : 'false');
  }
};

TagalysCustomisations.extractCartDrawerWidgetContent = function () {
  const widgetElement = TagalysCustomisations.getCartDrawerWidgetElement();
  if (!widgetElement || widgetElement.childNodes.length === 0) return null;

  const fragment = document.createDocumentFragment();
  while (widgetElement.firstChild) {
    fragment.appendChild(widgetElement.firstChild);
  }

  return fragment;
};

TagalysCustomisations.restoreCartDrawerWidgetContent = function (fragment) {
  const widgetElement = TagalysCustomisations.getCartDrawerWidgetElement();
  if (!widgetElement || !fragment || fragment.childNodes.length === 0 || widgetElement.childNodes.length > 0) return;

  widgetElement.appendChild(fragment);
};

TagalysCustomisations.isCartDrawerWidgetReady = function (widgetElement) {
  if (!widgetElement) return false;

  return Boolean(
    widgetElement.querySelector('.products.display-carousel') &&
      widgetElement.querySelector('[data-tagalys-product-card]')
  );
};

TagalysCustomisations.clearCartDrawerWidgetLoading = function () {
  if (TagalysCustomisations.cartDrawerWidgetLoadingObserver) {
    TagalysCustomisations.cartDrawerWidgetLoadingObserver.disconnect();
    TagalysCustomisations.cartDrawerWidgetLoadingObserver = null;
  }

  if (TagalysCustomisations.cartDrawerWidgetLoadingTimeout !== null) {
    clearTimeout(TagalysCustomisations.cartDrawerWidgetLoadingTimeout);
    TagalysCustomisations.cartDrawerWidgetLoadingTimeout = null;
  }

  TagalysCustomisations.setCartDrawerWidgetLoading(TagalysCustomisations.getCartDrawerWidgetHost(), false);
};

TagalysCustomisations.clearCartDrawerWidgetRefresh = function () {
  if (TagalysCustomisations.cartDrawerWidgetRefreshFrame !== null) {
    cancelAnimationFrame(TagalysCustomisations.cartDrawerWidgetRefreshFrame);
    TagalysCustomisations.cartDrawerWidgetRefreshFrame = null;
  }

  if (TagalysCustomisations.cartDrawerWidgetRefreshTimeout !== null) {
    clearTimeout(TagalysCustomisations.cartDrawerWidgetRefreshTimeout);
    TagalysCustomisations.cartDrawerWidgetRefreshTimeout = null;
  }
};

TagalysCustomisations.refreshCartDrawerWidget = function () {
  const widgetElement = TagalysCustomisations.getCartDrawerWidgetElement();
  if (!window.Tagalys || !widgetElement) return;

  const widgetHost = TagalysCustomisations.getCartDrawerWidgetHost(widgetElement);
  const productIds = TagalysCustomisations.getProductBasedWidgetProductIds();

  TagalysCustomisations.clearCartDrawerWidgetLoading();
  TagalysCustomisations.setCartDrawerWidgetLoading(widgetHost, true);

  TagalysCustomisations.setTagalysConfiguration();
  TagalysCustomisations.setPlatformConfiguration();
  TagalysCustomisations.initProductBasedWidget({
    selector: TagalysCustomisations.getProductBasedWidgetSelector(widgetElement),
    productIds,
  });

  if (TagalysCustomisations.isCartDrawerWidgetReady(widgetElement)) {
    TagalysCustomisations.clearCartDrawerWidgetLoading();
    return;
  }

  TagalysCustomisations.cartDrawerWidgetLoadingObserver = new MutationObserver(() => {
    if (!TagalysCustomisations.isCartDrawerWidgetReady(widgetElement)) return;

    TagalysCustomisations.clearCartDrawerWidgetLoading();
  });

  TagalysCustomisations.cartDrawerWidgetLoadingObserver.observe(widgetElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'src'],
  });

  TagalysCustomisations.cartDrawerWidgetLoadingTimeout = window.setTimeout(() => {
    TagalysCustomisations.clearCartDrawerWidgetLoading();
  }, 2500);
};

TagalysCustomisations.scheduleCartDrawerWidgetRefresh = function ({ cartData } = {}) {
  TagalysCustomisations.syncCartDrawerRecommendationContext(cartData);
  TagalysCustomisations.clearCartDrawerWidgetRefresh();

  TagalysCustomisations.cartDrawerWidgetRefreshFrame = requestAnimationFrame(() => {
    TagalysCustomisations.cartDrawerWidgetRefreshFrame = null;
    TagalysCustomisations.cartDrawerWidgetRefreshTimeout = window.setTimeout(() => {
      TagalysCustomisations.cartDrawerWidgetRefreshTimeout = null;
      TagalysCustomisations.refreshCartDrawerWidget();
    }, 0);
  });
};

TagalysCustomisations.clearCartDrawerEmptyState = function (cartElement) {
  if (!cartElement || cartElement.tagName !== 'CART-DRAWER') return;

  cartElement.classList.remove('is-empty');
  cartElement.querySelector('.drawer__inner')?.classList.remove('is-empty');
  cartElement.querySelector('cart-drawer-items')?.classList.remove('is-empty');
};

TagalysCustomisations.addVariantToCart = async function ({ variantId, buttonElement }) {
  const cardElement = buttonElement?.closest('[data-tagalys-product-card]');
  const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

  if (!variantId || !buttonElement) {
    TagalysCustomisations.setQuickAddError(cardElement, window.tagalysConfig.cartError);
    return;
  }

  TagalysCustomisations.setQuickAddError(cardElement);
  TagalysCustomisations.setQuickAddLoading(buttonElement, true);

  try {
    const config = typeof fetchConfig === 'function' ? fetchConfig('javascript') : { method: 'POST', headers: {} };
    config.headers = config.headers || {};
    config.headers.Accept = 'application/javascript';
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData();
    formData.append('items[0][id]', variantId);
    formData.append('items[0][quantity]', 1);

    if (cart) {
      formData.append(
        'sections',
        cart.getSectionsToRender().map((section) => section.id)
      );
      formData.append('sections_url', window.location.pathname);
      if (typeof cart.setActiveElement === 'function') {
        cart.setActiveElement(document.activeElement);
      }
    }

    config.body = formData;

    const response = await fetch(`${routes.cart_add_url}`, config).then((result) => result.json());

    if (response.status) {
      TagalysCustomisations.setQuickAddError(
        cardElement,
        response.description || response.message || window.tagalysConfig.cartError
      );
      return;
    }

    TagalysCustomisations.setLastAddedProductId(TagalysCustomisations.getProductIdFromCartAddResponse(response));

    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'tagalys-quick-add',
        productVariantId: variantId,
        cartData: response,
      });
    }

    if (!cart) {
      window.location = window.routes.cart_url;
      return;
    }

    TagalysCustomisations.clearCartDrawerEmptyState(cart);
    cart.renderContents(response);
  } catch (_error) {
    TagalysCustomisations.setQuickAddError(cardElement, window.tagalysConfig.cartError);
  } finally {
    TagalysCustomisations.clearCartDrawerEmptyState(cart);
    TagalysCustomisations.setQuickAddLoading(buttonElement, false);
  }
};

TagalysCustomisations.setTagalysConfiguration = function () {
  const configuration = {
    api: {
      serverUrl: defaultTagalysServerUrl,
    },
    locale: defaultTagalysLocale,
    currency: {
      displayFormatter: '{{currencyLabel}}{{value}}',
      code: defaultTagalysCurrencyCode,
      label: defaultTagalysCurrencyLabel,
      fractionalDigits: 2,
      forceFractionalDigits: true,
    },
    analyticsStorageConsentProvided() {
      const privacyConsent = window.Shopify?.customerPrivacy;

      if (!privacyConsent || typeof privacyConsent.analyticsProcessingAllowed !== 'function') {
        return false;
      }

      return privacyConsent.analyticsProcessingAllowed();
    },
    track: true,
  };
  Tagalys.setConfiguration(configuration);
};

TagalysCustomisations.setPlatformConfiguration = function () {
  const platformConfiguration = {
    platform: 'Shopify',
    countryCode: defaultTagalysCountry,
    baseCountryCode: defaultTagalysBaseCountry,
    waitForStorefrontAPI: true,
    useStorefrontAPIForSecondaryMarkets: true,
    storefrontAPI: {
      accessToken: storefrontApiAccessToken,
      myShopifyDomain: window.Shopify.shop,
    },
    metafields: {
      products: [],
    },
  };
  Tagalys.setPlatformConfiguration(platformConfiguration);
};

TagalysCustomisations.initProductBasedWidget = function ({ selector, productIds } = {}) {
  const resolvedProductIds =
    Array.isArray(productIds) && productIds.length > 0
      ? productIds
      : TagalysCustomisations.getProductBasedWidgetProductIds();

  if (!selector || resolvedProductIds.length === 0) return;

  Tagalys.UIWidgets.Recommendations.init(selector, {
    recommendationId: tagalysProductBasedRecommendationId,
    productIds: resolvedProductIds,
    templates: {
      header: {
        render: (html, args) => {
          const props = args.props;
          const heading = window.cartDrawerSettings.upsellHeading || props.helpers.getAPIResponse().title;
          return html`
            <div class="cart-drawer__upsells-heading-wrapper exclude-tagalys-css-reset">
              <h3
                class=${`cart-drawer__upsells-heading exclude-tagalys-css exclude-tagalys-css-reset`}
                style="color: var(--color-brand-black); margin-right: 8rem; font-size: calc(var(--font-heading-scale) * 2rem); line-height: 3.2rem; letter-spacing: calc(var(--font-heading-scale) * 2rem * -1 / 100); font-weight: var(--font-heading-weight);"
              >
                ${heading}
              </h3>
            </div>
          `;
        },
      },
      loader: {
        render(html) {
          return html`
            <div class="cart-drawer__upsells-loading-spinner loading__spinner">
              <svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66">
                <circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path" />
              </svg>
            </div>
          `;
        },
      },
      widget: {
        options: {
          count: 16,
          displayFormat: 'carousel',
          carouselOptions: {
            perPage: 2,
            duration: 200,
            easing: 'ease-out',
            startIndex: 0,
            draggable: true,
          },
        },
      },
      carouselActions: {
        render: (html, args) => {
          const props = args.props;
          return html`
            <div
              class="cart-drawer__upsells-carousel-actions exclude-tagalys-css exclude-tagalys-css-reset"
              style="display: flex; gap: 0.8rem; position: absolute; top: -4.8rem; right: 0.8rem;"
            >
              <${args.templates.leftArrow}
                disabled=${props.helpers.carousel.isFirstSlide()}
                goLeft=${props.helpers.carousel.goLeft}
              />
              <${args.templates.rightArrow}
                disabled=${props.helpers.carousel.isLastSlide()}
                goRight=${props.helpers.carousel.goRight}
              />
            </div>
          `;
        },
      },
      leftArrow: {
        render(html, args) {
          const props = args.props;
          return html`
            <button
              class=${`cart-drawer__slider-arrow splide__arrow splide__arrow--secondary cart-drawer__slider-arrows--prev exclude-tagalys-css-reset ${props.disabled ? 'disabled' : ''}`}
              onClick=${props.disabled ? undefined : props.goLeft}
              aria-label=${window.tagalysConfig.previousSlide}
              disabled=${props.disabled}
              style="color: var(--color-brand-black); width: 3.2rem; height: 3.2rem;"
            >
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16">
                <path
                  fill="none"
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-width="1.5"
                  d="M7.333 11.333 4 8m0 0 3.333-3.333M4 8h8"
                />
              </svg>
            </button>
          `;
        },
      },
      rightArrow: {
        render(html, args) {
          const props = args.props;
          return html`
            <button
              class=${`cart-drawer__slider-arrow splide__arrow splide__arrow--secondary cart-drawer__slider-arrows--next exclude-tagalys-css-reset ${props.disabled ? 'disabled' : ''}`}
              onClick=${props.disabled ? undefined : props.goRight}
              aria-label=${window.tagalysConfig.nextSlide}
              disabled=${props.disabled}
              style="color: var(--color-brand-black); width: 3.2rem; height: 3.2rem;"
            >
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-arrow-left" viewBox="0 0 16 16">
                <path
                  fill="none"
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-width="1.5"
                  d="M8.667 4.667 12 8m0 0-3.333 3.333M12 8H4"
                />
              </svg>
            </button>
          `;
        },
      },
      product: {
        render: (html, args) => {
          const props = args.props;
          const product = props.product;
          const helpers = props.helpers;
          const productOptions = helpers.getTemplateOptions('product');
          const productLink = productOptions.productPageUrl(product);
          const { variants, availableVariants, firstAvailableVariant, hasVariantSelector } =
            TagalysCustomisations.getQuickAddState(product);
          const productCanBeAdded = availableVariants.length > 0;
          const displayVariant = firstAvailableVariant || variants[0] || null;

          // If the product is not available, don't render the card
          if (!helpers.isStorefrontAPICallPending() && !productCanBeAdded) {
            return null;
          }

          // Determine if user is dragging the carousel or not and prevent click of product link during dragging.
          const dragState = TagalysCustomisations.recommendationCarouselDragState;

          const handlePointerDown = (event) => {
            dragState.startX = event.clientX;
            dragState.startY = event.clientY;
            dragState.isPointerDown = true;
            dragState.allowClick = true;
            dragState.activePointerId = event.pointerId;
            event.currentTarget.setPointerCapture?.(event.pointerId);
          };

          const handlePointerMove = (event) => {
            if (!dragState.isPointerDown || dragState.activePointerId !== event.pointerId) return;

            const deltaX = Math.abs(event.clientX - dragState.startX);
            const deltaY = Math.abs(event.clientY - dragState.startY);

            // Only suppress clicks once the gesture is clearly a horizontal carousel drag.
            if (deltaX > 12 && deltaX > deltaY) {
              dragState.allowClick = false;
            }
          };

          const handlePointerUp = (event) => {
            if (dragState.activePointerId !== event.pointerId) return;

            event.currentTarget.releasePointerCapture?.(event.pointerId);
            dragState.isPointerDown = false;
          };

          const handlePointerCancel = (event) => {
            if (dragState.activePointerId !== null && dragState.activePointerId !== event.pointerId) return;

            event.currentTarget.releasePointerCapture?.(event.pointerId);
            TagalysCustomisations.resetRecommendationCarouselDragState();
          };

          const handleProductLinkClick = (event) => {
            const href = event.currentTarget.href;
            if (!dragState.allowClick) {
              TagalysCustomisations.stopCardInteraction(event);
              TagalysCustomisations.resetRecommendationCarouselDragState();
              return;
            }
            event.preventDefault();
            TagalysCustomisations.resetRecommendationCarouselDragState();
            window.location.assign(href);
          };

          // Add product to cart.
          const handleAddToBag = (event) => {
            TagalysCustomisations.stopCardInteraction(event);

            const cardElement = event.currentTarget.closest('[data-tagalys-product-card]');
            const variantSelect = cardElement?.querySelector('[data-tagalys-variant-select]');
            const selectedVariantId = variantSelect?.value || firstAvailableVariant?.id;

            TagalysCustomisations.addVariantToCart({
              variantId: selectedVariantId,
              buttonElement: event.currentTarget,
            });
          };

          const handleProductImageLoad = (event) => {
            event.currentTarget.classList.add('is-loaded');
            event.currentTarget.closest('.cart-drawer__product-card-image-container')?.classList.add('is-loaded');
          };

          const handleVariantChange = (event) => {
            const cardElement = event.currentTarget.closest('[data-tagalys-product-card]');
            TagalysCustomisations.updateProductCardPrices(cardElement, helpers, variants, firstAvailableVariant);
          };

          const isOnSale = displayVariant
            ? helpers.isProductOnSale(displayVariant.compare_at_price, displayVariant.price)
            : false;
          const saleFormatted = displayVariant ? helpers.formatCurrency(displayVariant.price) : '';
          const regularFormatted = displayVariant
            ? isOnSale
              ? helpers.formatCurrency(displayVariant.compare_at_price)
              : saleFormatted
            : '';

          const regularPriceSpanClass =
            'cart-drawer__product-card-price cart-drawer__product-card-price--regular product-price-regular';
          const salePriceSpan = isOnSale
            ? html`
                <span
                  class="cart-drawer__product-card-price cart-drawer__product-card-price--discounted product-price-discounted"
                  >${saleFormatted}</span
                >
              `
            : null;
          const regularPriceSpan = isOnSale
            ? html`<span class=${regularPriceSpanClass}
                >${helpers.formatCurrency(displayVariant.compare_at_price)}</span
              >`
            : html`<span class=${regularPriceSpanClass}>${regularFormatted}</span>`;

          return html`
            <div
              class="cart-drawer__product-card product-card exclude-tagalys-css exclude-tagalys-css-reset"
              data-tagalys-product-card
            >
              <a
                class="cart-drawer__product-card-link product-link"
                href=${productLink}
                draggable="false"
                onPointerDown=${handlePointerDown}
                onPointerMove=${handlePointerMove}
                onPointerUp=${handlePointerUp}
                onPointerCancel=${handlePointerCancel}
                onClick=${handleProductLinkClick}
              >
                <div
                  class=${`cart-drawer__product-card-image-container product-image-container ${
                    product.featured_image ? '' : 'is-loaded'
                  }`}
                >
                  ${product.featured_image
                    ? html`<img
                        class="cart-drawer__product-card-image product-image"
                        data-src=${product.featured_image.src}
                        alt=${product.title}
                        draggable="false"
                        onLoad=${handleProductImageLoad}
                        onError=${handleProductImageLoad}
                      />`
                    : null}
                </div>
                <div class="cart-drawer__product-card-details product-details">
                  <h4 class="cart-drawer__product-card-title body-xxs-bold product-name">${product.title}</h4>
                  <p class="cart-drawer__product-card-variant body-xxs"></p>
                  ${helpers.isStorefrontAPICallPending()
                    ? html`<span class="skeleton-box cart-drawer__product-card-price-skeleton"></span>`
                    : html`<span
                        class=${`cart-drawer__product-card-prices body-xxs-bold product-prices ${
                          isOnSale ? ' discounted' : ' full-price'
                        }`}
                        data-tagalys-product-prices
                      >
                        ${salePriceSpan} ${regularPriceSpan}
                      </span>`}
                </div>
              </a>
              ${helpers.isStorefrontAPICallPending()
                ? null
                : html`
                    <div class="cart-drawer__product-card-actions">
                      ${hasVariantSelector
                        ? html`
                            <label class="visually-hidden" for=${`tagalys-variant-select-${product.id}`}>
                              ${`${window.tagalysConfig.selectVariantOf}${product.title}`}
                            </label>
                            <div class="cart-drawer__product-card-select">
                              <select
                                id=${`tagalys-variant-select-${product.id}`}
                                class="cart-drawer__product-card-select-input"
                                data-tagalys-variant-select
                                aria-label=${`${window.tagalysConfig.variantOf}${product.title}`}
                                onChange=${handleVariantChange}
                              >
                                ${variants.map((variant) => {
                                  const isAvailable = variant.available !== false;
                                  return html`
                                    <option
                                      value=${variant.id}
                                      selected=${String(variant.id) === String(firstAvailableVariant?.id)}
                                      disabled=${!isAvailable}
                                    >
                                      ${TagalysCustomisations.getVariantLabel(variant)}
                                    </option>
                                  `;
                                })}
                              </select>
                            </div>
                          `
                        : html`<p class="cart-drawer__product-card-variant-title">${displayVariant.title}</p>`}
                      <button
                        type="button"
                        class="cart-drawer__product-card-add button button--primary"
                        aria-label=${window.tagalysConfig.addToCart}
                        onClick=${handleAddToBag}
                        disabled=${!productCanBeAdded}
                      >
                        <span data-tagalys-add-label
                          >${productCanBeAdded ? window.tagalysConfig.add : window.tagalysConfig.unavailable}</span
                        >
                      </button>
                      <p class="cart-drawer__product-card-error caption" data-tagalys-quick-add-error hidden></p>
                    </div>
                  `}
            </div>
          `;
        },
      },
    },
  });
};
